import React, { Component } from 'react'
import 'jquery/dist/jquery.min.js';
import ls from 'local-storage'

//Datatable Modules
import "datatables.net-dt/js/dataTables.dataTables"
import "datatables.net-dt/css/jquery.dataTables.min.css"
import $ from 'jquery'; 

export class Worklist extends Component {
    componentDidMount(){
        document.title = "Agency Work List"
        const loginToken = ls.get('loginToken');
          this.$el =$(this.el);
          this.$el.DataTable({
              "scrollY":        "500px",
              "scrollX":        true,
              "scrollCollapse": true,	   
              "aLengthMenu": [
                  [10,25, 50, 100, -1],
                  [10,25, 50, 100, "All"]
              ],		
              "processing": true,
              'language': {
                  'loadingRecords': '&nbsp;',
                  'processing': '<div class="spinner_datatable"></div>'
              },
              "serverSide": true,
              "ajax": {
              url : `${process.env.REACT_APP_API_URL}contractor/getworkdetails/agencyid/`+this.props.children,
              type: "POST",          
              headers: { 'Authorization': 'bearer '+loginToken } 
              },
              "createdRow": function(row, data) {
                       if(data['number_of_month'] === 10)
                           $(row).addClass("danger");
                       else if(data['number_of_month'] === 20)
                           $(row).addClass("info");
                       else
                           $(row).addClass("gradeA");
                      },	
                      "columnDefs": [ {
                        targets: 6,
                        className: 'text-right'
                    },{
                        targets: 7,
                        className: 'text-right'
                    }],
              "order": [[ 1, 'DESC' ]],
              "columns": [
                  {
                    title: "Work Head",
                    data:"workhed"
                  }, {
                    title: "Partwork Name",
                    data:"partworkname"
                  }, {
                    title: "Work Name",
                    data:"workname"
                  }, {
                    title: "Office Name",
                    data:"officesname"
                  }, {
                    title: "Progress Percent",
                    data:"progress_percent"
                  }, {
                    title: "Status",
                    data:"statusname"
                  }, {
                    title: "Total Tender Approved Amount (In lakhs )",
                    data:"tenderapprovedamount"
                  }, {
                    title: "Total Bill Amount",
                    data:"total_bill_amount"
                  }
              ],
          }
          )
      }
      componentWillUnmount() {
        $(".display").find("table").DataTable().destroy(true);
      }    
    render() {
        return (
            <div className="box-body">
                <div className="box-header">
                        <h3 className="box-title">Work Details</h3>
                </div>               
                <div className="col-md-12">
                    <table className="table table-hover table-bordered" width="100%" ref={el => this.el =el}></table>
                </div>		 
            </div>
        )
    }
}

export default Worklist
